export const INITIAL_PAGE = 0;

export const FETCH_SIZE_INFINITY = 10;

export const PAGINATION_FARM_STEP_ITEMS = 20;
